// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img_size_cal {
  width: 32px;
}

.img_size_cal_menu {
  width: 18px;
  cursor: pointer;
}

.icon_after {
  /* Hide the default dropdown arrow */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Add a custom icon */
  background-image: url("https://www.iconpacks.net/icons/2/free-arrow-down-icon-3101-thumb.png");
  background-repeat: no-repeat;
  background-position: right 50%;
  padding-right: 5px;
  /* Adjust the padding to your preference */
  padding-left: 10px;
  /* Adjust the padding to your preference */
  border: 1px solid #ccc;
  /* Optional: Add a border for visual distinction */
  /* Add a background color */
  background-color: red;
  /* Replace with your desired background color */
  color: white;
  /* Optional: Adjust the text color for better contrast */
}

.overflow_stop_sll_pages::-webkit-scrollbar {
  display: none !important;
}

.bod_overflow {
  height: 100vh;
  width: 100vw;
  overflow-y: hidden;
  overflow-x: hidden;
}

.bod_overflow::-webkit-scrollbar {
  display: none !important;
}

.img_size_cal_menu1 {
  width: 15px;
  cursor: pointer;
}

.img_size_cal_menu2 {
  width: 20px;
  cursor: pointer;
}

.flex_in_calendex_bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex_in_calendex_bar1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
}

.hr_style {
  background: #f3f3f3;
  width: 20px;
  height: 1px;
  padding-left: 18px;
}

.button_styling {
  color: #530;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  border-radius: 6px !important;
  background-color: #ffd705 !important;
  line-height: 15px;
}

.staff_prof_font {
  color: #424242;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28.8px;
  /* 180% */
}

.styling_remove_link_tag {
  text-decoration: none;
  color: black;
}

.width_profile_header {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid white;
}

.second_nav {
  border-bottom: 1px solid #e4e4e4;
}

.side_menu_btn {
  visibility: hidden;
}

@media (max-width: 500px) {
  .side_menu_btn {
    visibility: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/SideNavBar/SideNav.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,oCAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,8FAAA;EACA,4BAAA;EACA,8BAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kDAAA;EAEA,2BAAA;EACA,qBAAA;EACA,+CAAA;EACA,YAAA;EACA,wDAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,WAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,oCAAA;EACA,iBAAA;AADF;;AAIA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA;EACE,qBAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AADF;;AAIA;EACE,gCAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE;IACE,mBAAA;EADF;AACF","sourcesContent":[".img_size_cal {\n  width: 32px;\n}\n\n.img_size_cal_menu {\n  width: 18px;\n  cursor: pointer;\n}\n\n.icon_after {\n  /* Hide the default dropdown arrow */\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  /* Add a custom icon */\n  background-image: url(\"https://www.iconpacks.net/icons/2/free-arrow-down-icon-3101-thumb.png\");\n  background-repeat: no-repeat;\n  background-position: right 50%;\n  padding-right: 5px;\n  /* Adjust the padding to your preference */\n  padding-left: 10px;\n  /* Adjust the padding to your preference */\n  border: 1px solid #ccc;\n  /* Optional: Add a border for visual distinction */\n\n  /* Add a background color */\n  background-color: red;\n  /* Replace with your desired background color */\n  color: white;\n  /* Optional: Adjust the text color for better contrast */\n}\n\n.overflow_stop_sll_pages::-webkit-scrollbar {\n  display: none !important;\n}\n\n.bod_overflow {\n  height: 100vh;\n  width: 100vw;\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n\n.bod_overflow::-webkit-scrollbar {\n  display: none !important;\n}\n\n.img_size_cal_menu1 {\n  width: 15px;\n  cursor: pointer;\n}\n\n.img_size_cal_menu2 {\n  width: 20px;\n  cursor: pointer;\n}\n\n.flex_in_calendex_bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.flex_in_calendex_bar1 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: end;\n}\n\n.hr_style {\n  background: #f3f3f3;\n  width: 20px;\n  height: 1px;\n  padding-left: 18px;\n}\n\n.button_styling {\n  color: #530;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  border-radius: 6px !important;\n  background-color: #ffd705 !important;\n  line-height: 15px;\n}\n\n.staff_prof_font {\n  color: #424242;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28.8px;\n  /* 180% */\n}\n\n.styling_remove_link_tag {\n  text-decoration: none;\n  color: black;\n}\n\n.width_profile_header {\n  width: 33px;\n  height: 33px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid white;\n}\n\n.second_nav {\n  border-bottom: 1px solid #e4e4e4;\n}\n\n.side_menu_btn {\n  visibility: hidden;\n}\n\n@media (max-width: 500px) {\n  .side_menu_btn {\n    visibility: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
